import LanguageEnum from "../../enums/language.enum";

export interface ILinkPlayerProps {
  hierarchyId: string;
  pathId: number;
  pathVersion: number;
  attemptId: string;
  studentId?: string;
  mode: string;
  isPreview: boolean;
  language: string;
  externalTokenKey: string;
  hideExitButton: boolean;
  ctkEnvId?: string;
  ctkEnvUrl?: string;
  setError?: (errorMessage: string) => void;
}

export interface ILinkPlayerLoaderProps {
  playerBaseUrl: string;
  linkPlayerProps: ILinkPlayerProps;
}

export interface IEducatorLinkPlayerProps {
  lessonHierarchyId: string;
  selectedLanguage: LanguageEnum;
  reviewActivities?: IActivity[];
  selectedReviewActivity?: IActivity;
  isReview: boolean;
  studentId?: string;
  ctkEnvId?: string;
  ctkEnvUrl?: string;
  playerBaseUrl: string;
}

export interface IActivity {
  pathId: number;
  takeId?: string;
  pathVersion: number;
  isMasteryCheck: boolean;
  title: string;
  type: string;
  isCompleted: boolean;
  score: number | null;
  timeSpentInSeconds?: number;
}

export const LanguageEnumNames = ["English", "Spanish"];

export const LinkPlayerLanguages = ["en", "es"];
